import { DeepPartial } from 'utility-types';
import {
  Record,
  String as RTString,
  Array as RTArray,
  Number as RTNumber,
  Undefined,
  Static,
  Boolean as RTBoolean
} from 'runtypes';
import { buildService } from './decorated-service';
import { Address } from '../../../core/types/address';
import { Phone } from '../../../core/types/phone';
import { purgeEmptyFields, removeExtraAddressFields } from './util';
import settings from '../../../settings.json';

const api = buildService('/new-account-svc/service/account/ocr-pdf');

export const ocrPDFServiceMock = {
  s3FileName:
    'webnasu-new-account-svc-trp-dev-mft-ocr-pdfs/generated/ocr-dev_20210804151158_XXXXXXXXX.pdf',
  success: true,
  errorDetails: null
};

export const OCRPDFPayload = Record({
  customer: Record({
    name: Record({
      firstName: RTString,
      middleName: RTString.Or(Undefined),
      lastName: RTString,
      suffix: RTString.Or(Undefined)
    }),
    citizenship: RTString,
    dob: RTString,
    taxID: RTString,
    taxIDType: RTString,
    residentialAddress: Address,
    mailingAddress: Address,
    primaryEmailAddress: RTString,
    phones: RTArray(Phone)
  }),
  rolloverDetails: Record({
    funds: RTArray(
      Record({
        fundName: RTString,
        accountNumber: RTString,
        amountPercent: RTNumber
      })
    ),
    planName: RTString,
    planNumber: RTString,
    rolloverAmount: RTNumber
  }).Or(Undefined),
  primaryBeneficiaries: RTArray(
    Record({
      name: RTString,
      taxID: RTString.Or(Undefined),
      relationship: RTString.Or(Undefined),
      percentage: RTNumber,
      dateOfBirth: RTString.Or(Undefined)
    })
  ).Or(Undefined),
  secondaryBeneficiaries: RTArray(
    Record({
      name: RTString,
      taxID: RTString.Or(Undefined),
      relationship: RTString.Or(Undefined),
      percentage: RTNumber,
      dateOfBirth: RTString.Or(Undefined)
    })
  ).Or(Undefined),
  paperless: RTBoolean,
  deliveryType: RTString,
  toAccountType: RTString
});

export type StaticOCRPDFPayload = Static<typeof OCRPDFPayload>;
export type OptionalOCRPDFPayload = DeepPartial<StaticOCRPDFPayload>;

export const createOCRPDFService = async (
  args: OptionalOCRPDFPayload
): Promise<any> => {
  if (settings['mockedMode']) return ocrPDFServiceMock;
  const validated: StaticOCRPDFPayload = OCRPDFPayload.check(args);
  const pdfPayload = purgeEmptyFields(validated, true);
  const finalPDFPayload = removeExtraAddressFields(pdfPayload);

  return api.add(finalPDFPayload);
};
